import Request from './request';
import env from '@/utils/env';
import IngeekJSAPI from '@/assets/js/ingeekjsapi';
const baseURL = env.baseURL;

export function getQaTypes(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/user/a/protocol/qa/v1/types`
  });
  return Request(config);
}

export function getSearchData(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/user/a/protocol/qa/v1/findAnswersByTitle`
  });
  return Request(config);
}
export function getAllData(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/user/a/protocol/qa/v1/allQas`
  });
  return Request(config);
}
export function getQADetail(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/user/a/protocol/qa/v1/detail`
  });
  return Request(config);
}
export function doFeedResult(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/user/a/protocol/qa/v1/saveFeedback`
  });
  return Request(config);
}

export function detailByRoleId(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/vehicle/public/v1/role/detailByRoleId`
  });
  return Request(config);
}

export function getDownloadApp(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/user/p/v2/qrcode/apkUrl`
  });
  return Request(config);
}

export function getCustomerServicePhone(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/vehicle/a/protocol/v1/getCustomerServicePhone`
  });
  return Request(config);
}

// 获取乘趣年报
export function getCQYearPort(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/user/a/v1/chengqu/getUserYearReport`
  });
  return Request(config);
}

// 获取大众年报
export function getYearPort(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/user/a/v2/tenant/getUserYearReport`
  });
  return Request(config);
}

// 上报乘趣埋点
export function uploadCQYearPortPoint(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/user/a/v1/chengqu/submitChengquUserYearReportEmbedData`
  });
  return Request(config);
}

// 上报大众埋点
export function uploadYearPortPoint(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/user/a/v1/public/reportEmbedData`
  });
  return Request(config);
}

// 上报数据埋点
export function uploadMonthPortPoint(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/user/a/v1/public/reportEmbedData`
  });
  return Request(config);
}

// 获取订单信息
export function getOrderInfo(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/membership/a/v2/member/getChangeDueByOrderInfo`
  });
  return Request(config);
}

// 确认支付
export function bornBillOrder(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/order/a/v1/confirmOrderForOmsChangeDueOrder`
  });
  return Request(config);
}

// 获取页面配置
export function getPageConfig(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/vehicle/a/v1/public/mobileH5Config`
  });
  return Request(config);
}
// 获取月度数据
export function getVehicleConfig(config = {}) {
  return new Promise(resolve => {
    IngeekJSAPI.doAppRequest(
      {
        path: 'vehicle/a/v3/getVehicleConfig',
        body: `${encodeURIComponent(JSON.stringify(config.data))}`
      },
      res => {
        resolve(res.data);
      }
    );
  });
}

// 获取月度数据
export function thirdGetMonthData(config = {}) {
  return new Promise(resolve => {
    config = Object.assign(config, {
      method: 'post',
      url: `${baseURL}/user/a/v1/public/getMonthReport`
    });
    if (env.isSVW) {
      Request(config).then(resolve).catch(resolve);
    } else {
      IngeekJSAPI.doAppRequest(
        {
          path: 'user/a/v1/getMonthReport',
          body: `${encodeURIComponent(JSON.stringify(config.data))}`
        },
        res => {
          console.error('响应数据：', res);
          resolve(res.data);
        }
      );
    }
  });
}

//
export function getVWRecommendFeature(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/vehicle/a/public/v1/findActivityMonthReportRecommend`
  });
  return Request(config);
}

// 获取用户信息
export function getIngeekUserInfo(config = { data: {} }) {
  return new Promise(resolve => {
    IngeekJSAPI.doAppRequest(
      {
        path: 'user/a/v1/queryUserInfo',
        body: `${encodeURIComponent(JSON.stringify(config.data))}`
      },
      res => {
        console.info('响应用户信息数据：', res);
        resolve(res.data);
      }
    );
  });
}

// 上传用户头像
export function uploadHeadPic(config = {}) {
  return new Promise(resolve => {
    IngeekJSAPI.doAppRequest(
      {
        path: 'user/a/v1/queryUserInfo',
        body: `${encodeURIComponent(JSON.stringify(config.data))}`
      },
      res => {
        console.error('响应上传头像数据', res);
        resolve(res.data);
      }
    );
  });
}

// 扫码二维码, 核销使用
export function checkQRCode(config = {}) {
  return new Promise(resolve => {
    IngeekJSAPI.doAppRequest(
      {
        path: 'vehicle/a/invite/v1/checkQRCode',
        body: `${encodeURIComponent(JSON.stringify(config.data))}`
      },
      res => {
        console.info('扫码二维码，核销使用', res);
        resolve(res.data);
      }
    );
  });
}

export function saveFeedback(config = {}) {
  return new Promise(resolve => {
    IngeekJSAPI.doAppRequest(
      {
        path: 'user/a/v1/saveFeedback',
        body: `${encodeURIComponent(JSON.stringify(config.data))}`
      },
      res => {
        resolve(res.data);
        console.info('响应意见反馈数据', res);
      }
    );
  });
}

// 判断核销码是否有效
export function isVerificationCodeValid(config = {}) {
  return new Promise(resolve => {
    IngeekJSAPI.doAppRequest(
      {
        path: 'vehicle/a/invite/v1/isVerificationCodeValid',
        body: `${encodeURIComponent(JSON.stringify(config.data))}`
      },
      res => {
        console.info('判断核销码是否有效', res);
        resolve(res.data);
      }
    );
  });
}

// 登录用户的邀请奖励列表
export function getInviteList(config = {}) {
  return new Promise(resolve => {
    IngeekJSAPI.doAppRequest(
      {
        path: '/vehicle/a/invite/v1/list',
        body: `${encodeURIComponent(JSON.stringify(config.data))}`
      },
      res => {
        console.info('登录用户的邀请奖励列表', res);
        resolve(res.data);
      }
    );
  });
}

// 登录用户的邀请统计信息
export function getInviteStatistics(config = {}) {
  return new Promise(resolve => {
    IngeekJSAPI.doAppRequest(
      {
        path: 'vehicle/a/invite/v1/statistics',
        body: `${encodeURIComponent(JSON.stringify(config.data))}`
      },
      res => {
        console.info('登录用户的邀请统计信息', res);
        resolve(res.data);
      }
    );
  });
}

// 获取活动状态
export function getActivityStatus(config = {}) {
  return new Promise(resolve => {
    IngeekJSAPI.doAppRequest(
      {
        path: 'vehicle/a/invite/v1/activityStatus',
        body: `${encodeURIComponent(JSON.stringify(config.data))}`
      },
      res => {
        console.info('获取活动状态', res);
        resolve(res);
      }
    );
  });
}

// 核销邀请码
export function verifyVerificationCode(config = {}) {
  return new Promise(resolve => {
    IngeekJSAPI.doAppRequest(
      {
        path: 'vehicle/a/invite/v1/verifyVerificationCode',
        body: `${encodeURIComponent(JSON.stringify(config.data))}`
      },
      res => {
        console.info('核销邀请码', res);
        resolve(res.data);
      }
    );
  });
}
// 根据语言代码和键获取国际化翻译
export function getTranslation(config = {}) {
  return new Promise(resolve => {
    IngeekJSAPI.doAppRequest(
      {
        path: 'vehicle/a/invite/v1/getTranslation',
        body: `${encodeURIComponent(JSON.stringify(config.data))}`
      },
      res => {
        console.info('根据语言代码和键获取国际化翻译', res);
        resolve(res.data);
      }
    );
  });
}

// 获取 API Key
export function getApiKey(config = {}) {
  return new Promise(resolve => {
    IngeekJSAPI.doAppRequest(
      {
        path: 'vehicle/a/v1/getApiKey',
        body: `${encodeURIComponent(JSON.stringify(config.data))}`
      },
      res => {
        console.log('获取 API Key 响应:', res);
        resolve(res);
      }
    );
  });
}

// 查询产品支持车型树
export function getVehicleModelTree(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/produce/h5/v1/product/vehicleModelTree`
  });
  return Request(config);
}

// 查询安装指导/说明书详情
export function findInstallAssistan(config = {}) {
  config = Object.assign(config, {
    method: 'post',
    url: `${baseURL}/vehicle/h5/v1/findInstallAssistant`
  });
  return Request(config);
}

// 提交问卷
export function submitQuestionnaire(config = {}) {
  return new Promise(resolve => {
    IngeekJSAPI.doAppRequest(
      {
        path: 'vehicle/h5/v1/questionnaire/submit',
        body: `${encodeURIComponent(JSON.stringify(config.data))}`
      },
      res => {
        console.log('提交问卷响应:', res);
        resolve(res);
      }
    );
  });
}

// 生成 API Key
export function generateApiKey(config = {}) {
  return new Promise(resolve => {
    IngeekJSAPI.doAppRequest(
      {
        path: 'vehicle/a/v1/generateApiKey',
        body: `${encodeURIComponent(JSON.stringify(config.data))}`
      },
      res => {
        console.log('生成 API Key 响应:', res);
        resolve(res);
      }
    );
  });
} 
